export default [
    { title: "Grandes despachos" },
    { title: "Despachos medianos" },
    { title: "Boutiques" },
   

    
  ];